module.exports = __webpack_public_path__ + "static/media/close-round.f68cae60.png";